import React, { useState } from "react";

import Avatar from "../assets/Avatar.png";
import { CircleButton } from "./Buttons";
import { Drawer } from "@material-ui/core";
import Radium from "radium";

const DrawerDetails = ({ children }) => {
  const [open, setOpen] = useState(false);

  const showDrawer = () => setOpen(true);
  const onClose = () => setOpen(false);

  return (
    <section style={styles}>
      <CircleButton img={Avatar} onClick={showDrawer} size={40} />
      <Drawer anchor="right" open={open} onClose={onClose}>
        {children}
      </Drawer>
    </section>
  );
};

export default Radium(DrawerDetails);

const query = {
  xs: "@media (max-width: 576px)",
  sm: "@media (max-width: 768px)",
  md: "@media (max-width: 992px)",
  lg: "@media (max-width: 1200px)",
  xl: "@media (max-width: 1600px)",
  small: "@media (max-width: 600px)",
  medium: "@media (max-width: 1440px)",
  large: "@media (max-width: 1700px)",
};

const styles = {
  display: "none",
  [query.lg]: { display: "flex", marginTop: "32px" },
  [query.sm]: { margin: "0 8px 0 0", alignItems: "center" },
};
